/* src/app/home/full-page-modal/full-page-modal.component.scss */
.main-content {
  padding-top: 25px;
}
/*# sourceMappingURL=full-page-modal.component.css.map */
